import React, { useState, useEffect} from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { API_ENDPOINTS } from './apiConfig';
import { getStatusMessage } from './statusMessages';
import { useAuth } from "./AuthContext";
import axios from 'axios';

function VerifyOtp() {
  const location = useLocation();
  const navigate = useNavigate();
  const { email,rotp } = location.state || {};

  const [otp, setOtp] = useState('');
  const [message, setMessage] = useState('');
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [animateArrow, setAnimateArrow] = useState(false);

  // ✅ OTP countdown lock
  const [sendingOtp, setSendingOtp] = useState(true);
  const [otpTimer, setOtpTimer] = useState(30);

  const { login} = useAuth();
  



  useEffect(() => {
    if (!email) navigate('/signup', { replace: true });
  }, [email, navigate]);


  // ✅ Countdown timer
  useEffect(() => {
    if (!sendingOtp) return;

    const interval = setInterval(() => {
      setOtpTimer(prev => {
        if (prev <= 1) {
          setSendingOtp(false);
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [sendingOtp]);


  const validateOtp = (value) => {
    const trimmed = value.trim();
    if (trimmed.length !== 6) return 'OTP should be 6 characters.';
    if (!/^[\x20-\x7E]*$/.test(trimmed)) return 'OTP contains invalid characters.';
    return '';
  };


  const handleChangeEmail = () => navigate('/signup');


  const handleVerify = async (e) => {
    e.preventDefault();
    setAnimateArrow(true);
    setErrors([]);
    setMessage('');
    setLoading(true);

    const otpError = validateOtp(otp);
    const device = 'web';

    if (otpError) {
      setErrors([otpError]);
      setLoading(false);
      setTimeout(() => setAnimateArrow(false), 1000);
      return;
    }

    try {
      const res = await axios.post(API_ENDPOINTS.VERIFY_OTP, {
        email,
        OTP: otp,
        device,
      });

      const { result, user, opt, token, errors: serverErrors } = res.data;

      if (result === 1) {
        setMessage(getStatusMessage(opt));
        login(token);
        navigate('/Details');
      } else {
        const allMessages = [];

        if (Array.isArray(serverErrors)) allMessages.push(...serverErrors);
        if (user !== undefined) allMessages.push(getStatusMessage(user));
        if (opt !== undefined) allMessages.push(getStatusMessage(opt));

        setErrors(allMessages.length ? allMessages : ['Verification failed.']);
      }
    } catch (err) {
      const status = err.response?.status;
      const data = err.response?.data;

      if (status === 400 && Array.isArray(data?.errors)) {
        setErrors(data.errors);
      } else if (status === 400 && (data?.user || data?.opt)) {
        const failMessages = [];
        if (data.opt !== undefined) failMessages.push(getStatusMessage(data.opt));
        setErrors(failMessages);
      } else {
        setErrors(['Server error. Please try again later.']);
      }
    } finally {
      setLoading(false);
      setTimeout(() => setAnimateArrow(false), 1000);
    }
  };

  return (
    <div style={{ maxWidth: 480, margin: '0 auto', paddingTop: '2rem' }}>

      {/* ✅ Inline CSS */}
      <style>{`
        .otp-lock {
          text-align: center;
          background: #fff0f7;
          border-radius: 14px;
          padding: 12px;
          margin-bottom: 12px;
          box-shadow: inset 0 0 6px #ffcae2;
        }
        .otp-spin {
          border: 4px solid #eee;
          border-top: 4px solid #ff69b4;
          border-radius: 50%;
          width: 26px;
          height: 26px;
          animation: spin 1s linear infinite;
          margin: 0 auto 8px;
        }
        .otp-barbox {
          background: #ffd6ea;
          border-radius: 6px;
          height: 6px;
          margin-top: 5px;
          overflow: hidden;
        }
        .otp-bar {
          background: #ff69b4;
          height: 100%;
          transition: width 1s linear;
        }
        @keyframes spin { to { transform: rotate(360deg); } }
      `}</style>

      <div style={{ maxWidth: 480, margin: '0 auto' }}>
        <h6 className="text-center wedding-heading">
          <span className="badge bg-secondary">Step 2 of 4</span>
        </h6>

        <div className="alert text-center mb-4" style={{
          backgroundColor: '#e6f0ff',
          color: '#003366',
          borderRadius: '12px',
          border: '1px solid #cce0ff'
        }}>
          Verifying: <strong>{email}</strong><br />
          {rotp && <div className="mt-2">{getStatusMessage(rotp)}</div>}

          <button className="btn btn-primary w-100 mt-3 d-flex align-items-center gap-2"
            onClick={handleChangeEmail}>
            <i className="bi bi-arrow-left-circle-fill"></i> Change Email
          </button>
        </div>

        {/* ✅ Lock UI */}
        {sendingOtp && (
          <div className="otp-lock">
            <div className="otp-spin"></div>
            <strong>Sending verification code…</strong>
            <div>{otpTimer} seconds remaining</div>
            <div className="otp-barbox">
              <div className="otp-bar" style={{ width: `${100 - (otpTimer / 30) * 100}%` }}></div>
            </div>
          </div>
        )}

        <form onSubmit={handleVerify}>
          <div className="mb-3">
            <label className="form-label text-muted">Enter OTP</label>
            <input
              type="text"
              className="form-control"
              placeholder="6-digit code"
              maxLength={6}
              value={otp}
              disabled={sendingOtp}
              onChange={(e) => setOtp(e.target.value)}
            />
          </div>

          <button
            type="submit"
            className="btn w-100 mt-3 d-flex justify-content-between align-items-center px-3"
            style={{ backgroundColor: '#ff69b4', color: 'white' }}
            disabled={sendingOtp || loading}
          >
            <span>{loading ? 'Verifying...' : 'Verify OTP'}</span>
            <i className={`bi bi-arrow-right-circle-fill ${animateArrow ? 'move-arrow' : ''}`} style={{ fontSize: '1.4rem' }}></i>
          </button>
        </form>

        {message && <div className="alert alert-success mt-3">{message}</div>}

        {errors.length > 0 && (
          <div className="alert alert-danger mt-3">
            <ul>{errors.map((e,i)=><li key={i}>{e}</li>)}</ul>
          </div>
        )}
      </div>

    </div>
  );
}

export default VerifyOtp;
